// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"mj","cardContent":"mk","editButton":"ml","innerHeading":"mm","header":"mn","subHeader":"mo"};